import { Injectable } from "@angular/core";

@Injectable()
export class ValidationMsgService {
  /**
   * Generates dynamic validation messages based on the error type and field label.
   * @param valErrors The validation errors object from the form control.
   * @param inputLabelName The display name of the field (e.g., 'Username', 'Password').
   */
  public getValidationMsg(valErrors: any, inputLabelName: string): string {
    const firstKey = Object.keys(valErrors)[0];

    if (firstKey == "required") {
      return inputLabelName + " is Required";
    } 
    
    else if (firstKey == "minlength") {
      return (
        inputLabelName +
        " must have " +
        valErrors.minlength.requiredLength +
        " characters"
      );
    } 
    
    else if (firstKey == "maxlength") {
      return (
        inputLabelName +
        " cannot exceed " +
        valErrors.maxlength.requiredLength +
        " characters"
      );
    } 
    
    else if (firstKey == "pattern") {
      // Specific handling for Password complexity requirements
      if (inputLabelName.toLowerCase().includes('password')) {
        return "Password must contain uppercase, lowercase, number and special character";
      }
      
      // Specific handling for Username formatting requirements
      if (inputLabelName.toLowerCase().includes('username')) {
        return "Username must start with a letter and contain no consecutive special characters";
      }

      // Default fallback for other pattern failures
      return inputLabelName + " is Invalid";
    } 
    
    else if (firstKey == "mismatch") {
      return "Password didn't match";
    } 
    
    else {
      return "Invalid Input";
    }
  }
}